module.exports = __webpack_public_path__ + "img/4.cb15a64d.png";